module.exports = __webpack_public_path__ + "img/switzerland-transport-accidents-female.6cddc29b.png";